import React from 'react';
import Image from 'components/UI/Image/Image';
import Heading from 'components/UI/Heading/Heading';
import TextLink from 'components/UI/TextLink/TextLink';
import NotFoundWrapper, { ContentWrapper } from './404.style';
import { useNavigate } from 'react-router-dom';

const NotFoundPage = ({ staticContext = {} }) => {
  const navigate = useNavigate();
  staticContext.status = 404;
  return (
    <NotFoundWrapper>
      <ContentWrapper>
        <Image src="/images/404@2x.png" alt="404" />
        <Heading as="h2" content="Quelque chose s'est mal passé" />
        <TextLink link="#" onClick={() => navigate(-1)}  content="Retourner" />
      </ContentWrapper>
    </NotFoundWrapper>
  );
};

export default NotFoundPage;
